import script from "./ClosestWinsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosestWinsPage.vue?vue&type=script&setup=true&lang=js"

import "./ClosestWinsPage.vue?vue&type=style&index=0&id=3e084dcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e084dcf"]])

export default __exports__